module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-creative-01.6db9340d.jpg";